<template>
  <div>
    <PageTitle
      title="User View"
      :backBtn="true"
      :editRoute="'/user/edit/' + this.$route.params.id"
      :permission="'User Edit'"
      :resetPasswordPermission="'User Reset Password'"
      :resetpass="true"
      @onResetPassword="onReset()"
    />

    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-card>
            <v-img :src="user.image" class="img-100" v-if="user.image"> </v-img>
            <v-img class="img-100" src="@/assets/user.png" v-else> </v-img>

            <v-list two-line class="pr-14">
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="indigo">mdi-id-card</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black"
                      >Full Name</v-list-item-title
                    >
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title
                      >{{ user.firstname }}
                      {{ user.lastname }}</v-list-item-title
                    >
                  </v-col>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mail</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black"
                      >Email</v-list-item-title
                    >
                  </v-col>

                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title>{{ user.email }}</v-list-item-title>
                  </v-col>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-account-group-outline</v-icon>
                </v-list-item-action>

                <v-list-item-content>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black"
                      >Roles</v-list-item-title
                    >
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title>
                      {{
                        user.roles[0] ? user.roles[0].name : '---'
                      }}</v-list-item-title
                    >
                  </v-col>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-card class="mb-0">
            <v-card-title>Contact</v-card-title>
            <v-list two-line class="pa-0">
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-phone-classic </v-icon>
                </v-list-item-action>
                <v-list-item-content class="ls-100">
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black">
                      Telephone Number
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.contacts ? user.contacts.telephone : '---'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-cellphone-basic</v-icon>
                </v-list-item-action>
                <v-list-item-content class="ls-100">
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black">
                      Mobile Number
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.contacts ? user.contacts.phone : '---'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-domain</v-icon>
                </v-list-item-action>
                <v-list-item-content class="ls-100">
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black">
                      Postal Code
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.address ? user.address.postal_code : '---'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-action>
                <v-list-item-content class="ls-100">
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black">
                      Address line 1
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.address ? user.address.address_line1 : '----'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-map-marker-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content class="ls-100">
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black pt-0 pb-0">
                      Address line 2
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.address ? user.address.address_line2 : '---'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-city-variant-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content class="ls-100">
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black">
                      City
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.address ? user.address.city : '---'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>
              <v-list-item href="#">
                <v-list-item-action>
                  <v-icon color="indigo">mdi-city-variant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-title class="font-weight-black">
                      Country
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6">
                    <v-list-item-subtitle>{{
                      user.address.country_name
                        ? user.address.country_name
                        : '---'
                    }}</v-list-item-subtitle>
                  </v-col>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" md="12" lg="12">
          <AuditLogs :Type="'users'" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { required, email, max, regex } from 'vee-validate/dist/rules';
import jwt_decode from 'jwt-decode';
import { User } from '../../../models/User';

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    name: '',
    email: '',
    isAdmin: false,
    value: String,
    select: null,
    roles: [],
    items: ['Item 1', 'Item 2', 'Item 3', 'Item 4'],
    checkbox: null,
    user: new User(),
    loginedUser: new User(),
    errors: [],
    oldUserDetails: new User(),
    messages: [],
  }),

  methods: {
    submit() {
      this.$refs.observer.validate();
      this.EditUser();
    },
    async onReset() {
      this.$confirm('Do you want to Reset Password ?').then((res) => {
        if (res) {
          let Credentials = this.$route.params.id;
          this.$store
            .dispatch('user/AdminResetPassword', Credentials)
            .then((res) => {
              this.succeeed = true;
              window.open(res.data.credential, '_blank');
            })
            .catch((err) => {
              this.messages.push(err.data);
              // this.$router.push("/pages/404");
            });
        }
      });
    },
    Reset() {
      this.user = this.oldUserDetails;
      this.$refs.observer.reset();
    },
    EditUser() {
      const selectedRoles = [];
      let userId = this.$route.params.id;
      this.$store
        .dispatch('user/EditUser', {
          id: userId,
          username: this.user.username,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          address: JSON.stringify(this.user.address),
          email: this.user.email,
          contacts: JSON.stringify(this.user.contacts),
          conmpany: this.user.username,
          password: this.user.password,
          roles: this.user.role,
          image: this.user.role,
        })
        .then((res) => {
          this.succeeed = true;
          this.$toast.success('User edited successfully');
        })
        .catch((err) => {
          this.messages = err.data.title;
          this.$toast.error('Edit failed');
        });
    },
    GetRoles() {
      this.$store
        .dispatch('user/GetRoles')
        .then((res) => {
          this.roles = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    getUser() {
      let userId = this.$route.params.id;

      this.$store
        .dispatch('user/GetSingleUser', userId)
        .then((res) => {
          this.succeeed = true;

          this.user = new User().initialise(res.data);
          if (this.user.image) {
            this.user.image = this.user.image + '?t=' + Date.now();
          }
        })
        .catch((err) => {
          this.messages.push(err.data);
          // this.$router.push("/pages/404");
        });
    },
  },
  created() {
    this.GetRoles();
    this.getUser();
  },
};
</script>

<style scoped>
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}

.rowspace {
  margin-top: -25px;
  margin-bottom: -40px;
}

.pr-100 {
  padding-right: 30px;
}

.ls-100 {
  margin-bottom: -7px;
  margin-top: -1px;
}

.img-100 {
  width: 20%;
  height: 20%;
  margin: auto !important;
}
</style>
